import clockIcon from "../../img/clock.png";
import { dummyRecentSearchHistoy } from "../../Config/SearchHistory";
import { useNavigate } from "react-router";
import { closeCatDD } from "../../Redux/Reducer/dropdown";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
const RecentSearch = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const recentSearchArray = localStorage.getItem("USER-SEARCH--HISTORY")
    ? JSON.parse(localStorage.getItem("USER-SEARCH--HISTORY")).concat(
        dummyRecentSearchHistoy
      )
    : dummyRecentSearchHistoy;
  return (
    <div className="card-wrap recent-search" style={{ paddingBottom: "0" }}>
      <div className="d-flex align-items-center justify-content-between sec-title">
        <div>
          <h2>{t("Recent Searches")}</h2>
        </div>
      </div>
      <div>
        {recentSearchArray.map((element, index) => (
          <a
            onClick={(e) => {
              e.preventDefault();
              dispatch(closeCatDD());
              navigate(`/${element}`);
              document.getElementById("myText").value = element;
              props.search(element);
            }}
            key={index}
            href="#"
            className="btn btn-outline-secondary rounded-pill"
          >
            <img src={clockIcon} alt="clock" width="16" /> {element}
          </a>
        ))}
      </div>
    </div>
  );
};
export default RecentSearch;
